import React from 'react';
import { ImageBackground, Text, View } from 'react-native';
import { ErrorPage } from 'Pages';
import { t } from 'Locale/index';
import { Button, Checkbox } from 'LocalGluons/index';
import { getActualWidth } from 'DeviceUtils';
// eslint-disable-next-line import/no-unresolved
import { getAssetImageUrl } from 'Utils';
import type { PlayerData } from 'Types';
import defaultStyles from './NetworkWarningDialog.jss';

interface NetworkWarningDialogProps {
    item: PlayerData['item'];
    onClose: () => void;
    onBack: () => void;
    onPlay: () => void;
    onCheckboxPress: (isChecked: any) => void;
}

const NetworkWarningDialog = ({
    item,
    onClose,
    onBack,
    onPlay,
    onCheckboxPress
}: NetworkWarningDialogProps): React.ReactElement => (
    <ImageBackground
        style={defaultStyles.previewImage}
        source={{ uri: getAssetImageUrl(item, 'PREVIEW') }}
    >
        <ErrorPage
            heading={t('COMMON.PLAY_OVER_MOBILE_NETWORK')}
            message={t('COMMON.USING_CELLULAR_PLAY_QUESTION')}
            mode="landscape"
            onClose={onClose}
        >
            <View style={defaultStyles.infoContent}>
                <View style={defaultStyles.buttonsContainer}>
                    <View style={defaultStyles.backButton}><Button isSecondary title={t('COMMON.BACK')} onPress={onBack} /></View>
                    <Button title={t('COMMON.PLAY')} onPress={onPlay} />
                </View>
                <View style={defaultStyles.checkboxContainer}>
                    <Checkbox
                        style={{ zIndex: 1 }}
                        hitSlop={{
                            top: 0,
                            bottom: 0,
                            left: 0,
                            right: getActualWidth()
                        }}
                        onPress={onCheckboxPress}
                    />
                    <Text style={defaultStyles.checkboxText}>{t('COMMON.DO_NOT_SHOW_AGAIN')}</Text>
                </View>
            </View>
        </ErrorPage>
    </ImageBackground>
);

export default NetworkWarningDialog;
